/**
 * æä¸¾ç±»: ç®åç³»ç»æ¯æçè´¦å·è§è²
 */
export enum AuthorityType {
  /**
   * æ®éç¨æ·
   */
  ROLE_USER = <any>'ROLE_USER',

  /**
   * å®ä¹ ç
   * @type {any}
   */
  ROLE_TRAINEE = <any>'ROLE_TRAINEE',

  /**
   * è§å¹æ¤å£«
   * @type {any}
   */
  ROLE_NEW_NURSE = <any>'ROLE_NEW_NURSE',

  /**
   * ç§æ·ç®¡çå
   */
  ROLE_TENANT = <any>'ROLE_TENANT',

  /**
   * åå®¹ç®¡çå
   */
  ROLE_CONTENT_ADMIN = <any>'ROLE_CONTENT_ADMIN',

  /**
   * å¹³å°ç®¡çå
   */
  ROLE_PLATFORM_ADMIN = <any>'ROLE_PLATFORM_ADMIN',

  /**
   * ç§å®¤/å°ç»ç®¡çåï¼åç«¯å¹¶æ æ­¤å­æ®µï¼åç«¯åå»ºæ­¤å­æ®µä¸ºæ¹ä¾¿ç¸å³ä½¿ç¨ï¼
   */
  ROLE_DEPT_ADMIN = <any>'ROLE_DEPT_ADMIN'
}
